exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-modal .action-buttons .cancel{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.action-modal .action-item>.tabs .tab-content{padding:15px 0}.action-modal .action-item>.tabs .tab-content .tab-pane{overflow-y:auto;padding:15px 30px;height:calc(var(--window-height, 100vh) - 157px)}.action-modal .modal-body{padding:0}@media (min-width:768px){.action-modal .modal-body{padding:1rem}.action-modal .action-item>.tabs .tab-content .tab-pane{height:calc(var(--window-height, 100vh) - 282px)}}", ""]);

// exports
